/**
 * @deprecated Avoid using this function as this module is deprecated.
 */
export function resolveAnimationValues<T>(
  value: T,
  custom?: any
): T extends () => any ? ReturnType<T> : T {
  return (
    typeof value === 'function' ? value(custom) : value
  ) as T extends () => any ? ReturnType<T> : T;
}
